export const maskText = (
  text: string,
  numCharsToShow: number = 5,
  maskChar: string = "*"
) => {
  if (numCharsToShow >= text.length) {
    return text;
  }

  const maskedPart = maskChar.repeat(text.length - numCharsToShow);
  const visiblePart = text.slice(-numCharsToShow);

  return maskedPart + visiblePart;
};
